import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

import Title from '../components/ui/Title/Title'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import Image from '../components/ui/Image/Image'
import CareerLayout from '../components/CareerLayout/CareerLayout'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'
import useIsMobile from '../hooks/useIsMobile'
import useFetch from '../hooks/useFetch'
import { getImageUrl, isArabic, isLanguage } from '../utils'

import styles from './pages.module.scss'
import arrow from '../assets/images/arrowUpRight.svg'
import { CAREER } from '../Contansts'
import { useLanguage } from '../context/LangaugeContextProvider/LangaugeContextProvider'

function Career() {
  const transferData = (resp) => resp.data
  const { data, loading, error } = useFetch(CAREER, transferData)
  const { language } = useLanguage()
  const { isSpanish, isFrench } = isLanguage(language?.code)
  const isArabicLang = isArabic(language?.code)

  const isMobile = useIsMobile()
  const {
    pagetitle: pageTitle,
    breadcrumbs,
    sectiondata,
    disclaimer_title,
    disclaimer_description,
    bgImage,
    mbBannerImage,
  } = data?.result || {}
  const { header, subheader: subHeader, lifeAtNipl } = sectiondata || {}

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <div
          className={styles.backgroundImage}
          style={{
            backgroundImage: !isMobile && `url(${getImageUrl(bgImage)})`,
          }}
        >
          <div className={classNames(styles.interoperability)}>
            <div className={classNames(styles.pageContent)}>
              <div
                className={classNames('page-container', styles.topContainer)}
              >
                <div className={styles.descriptionContainer}>
                  <Title
                    classname={classNames(
                      styles.pageTitle,
                      'page-title-padding'
                    )}
                  >
                    {pageTitle}
                  </Title>
                  <div
                    className={classNames(styles.headerSection, {
                      [styles.esHeaderSection]:
                        isSpanish || isFrench || isArabicLang,
                    })}
                  >
                    <div className={styles.headerContainer}>
                      <h2>{header}</h2>
                      <h3>{subHeader}</h3>
                    </div>
                    <Link
                      to={lifeAtNipl?.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                      {lifeAtNipl?.label}
                      <Image src={arrow} alt={lifeAtNipl?.ariaLabel} />
                    </Link>
                  </div>
                </div>
              </div>
              {isMobile && mbBannerImage && (
                <Image
                  src={getImageUrl(mbBannerImage)}
                  alt={mbBannerImage?.alternativeText}
                />
              )}
              <CareerLayout
                careerData={{
                  ...sectiondata,
                  disclaimer_description: disclaimer_description,
                  disclaimer_title: disclaimer_title,
                }}
                pagination={data.pagination}
              />
            </div>
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      )}
    </>
  )
}

export default Career
